<template>
  <div class="sjxq">
    <div v-if="facility=='app'" class="content">
      <AbApp/>
    </div>
    <div v-else>
      <Pc/>
    </div>
  </div>
</template>

<script>
import AbApp from "./app";
import Pc from "./pc";
export default {
  components:{
    AbApp,
    Pc
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>

</style>